var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTheFool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 436.56 353.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.8 165.88 21.41 161.35 7.3 170.85 11.83 154.46 2.34 140.35 18.73 144.88 32.83 135.38 28.31 151.77 37.8 165.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "231.84 45.27 222.35 31.16 205.46 29.18 219.56 19.69 221.54 2.8 231.03 16.91 247.92 18.88 233.82 28.38 231.84 45.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "240.13 255.02 233.6 270.72 241.27 285.9 225.57 279.37 210.4 287.04 216.92 271.34 209.26 256.16 224.96 262.69 240.13 255.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "409.04 344.97 392.65 340.44 378.54 349.93 383.07 333.54 373.58 319.44 389.97 323.97 404.07 314.47 399.54 330.86 409.04 344.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "434.22 163.42 417.83 158.9 403.72 168.39 408.25 152 398.76 137.89 415.15 142.42 429.26 132.93 424.73 149.32 434.22 163.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "77.52 346.63 61.13 342.1 47.03 351.59 51.56 335.2 42.06 321.1 58.45 325.63 72.56 316.13 68.03 332.52 77.52 346.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "209.82 206.23 216.92 190.78 209.82 175.34 225.26 182.44 240.71 175.34 233.61 190.78 240.71 206.23 225.26 199.13 209.82 206.23"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.41,
    y1: 161.35,
    x2: 58.45,
    y2: 325.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 216.92,
    y1: 271.34,
    x2: 68.03,
    y2: 332.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 383.07,
    y1: 333.54,
    x2: 233.6,
    y2: 270.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 389.97,
    y1: 323.97,
    x2: 417.83,
    y2: 158.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 408.25,
    y1: 152,
    x2: 233.61,
    y2: 190.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 216.92,
    y1: 190.78,
    x2: 28.31,
    y2: 151.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 225.26,
    y1: 182.44,
    x2: 226.69,
    y2: 24.03
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheFool);
export default __webpack_public_path__ + "static/media/TheFool.09c750947405b2d5626bfea990def7b3.svg";
export { ForwardRef as ReactComponent };